const EMERGENCY_STOCK_UNIT = [
  { value: 0, text: 'Weeks' },
  { value: 1, text: 'Months' },
  { value: 2, text: 'Boxes' }
];

type EMERGENCY_STOCK_UNIT = typeof EMERGENCY_STOCK_UNIT;

export default EMERGENCY_STOCK_UNIT;
